import { render } from "./GenericPicker.vue?vue&type=template&id=67e5a6e4"
import script from "./GenericPicker.vue?vue&type=script&lang=ts"
export * from "./GenericPicker.vue?vue&type=script&lang=ts"
script.render = render

export default script